export default __webpack_public_path__ + "static/media/webLink.7bb0a775.svg";